<div class="dashboard-card">
  <div class="card-header">
    <h4 class="card-title">Top 5 Consumed Products</h4>
  </div>
  <div class="card-content">
    <div *ngIf="isLoadingTopConsumedProducts" class="card-loading">
      <div class="loading-spinner"></div>
      <span>Loading top consumed products...</span>
    </div>
    <div *ngIf="!isLoadingTopConsumedProducts && (!topConsumedProductsData?.products || topConsumedProductsData.products.length === 0)" class="empty-state-message">
      <i class="fa fa-cubes empty-icon" aria-hidden="true"></i>
      <span>No consumed product data available for the selected date range.</span>
    </div>
    <canvas #chart2 class="chart-canvas" [style.display]="isLoadingTopConsumedProducts || !topConsumedProductsData?.products || topConsumedProductsData.products.length === 0 ? 'none' : 'block'"></canvas>
  </div>
</div>
